import './App.css';
import { Layout } from './Pages/Layout.jsx';
import { HomePage } from './Pages/HomePage';
import { ProductPage } from './Pages/ProductPage';
import { DocumentAIPage } from './Pages/DocumentAIPage';
import { LoginPage } from './Pages/LoginPage';
import { RegistrationPage } from './Pages/RegistrationPage';
import { UnlockPage } from './Pages/UnlockPage';
import { ForgotPasswordPage } from './Pages/ForgotPasswordPage/ForgotPasswordPage.jsx';
import { ResetPasswordPage } from './Pages/ResetPasswordPage/ResetPasswordPage.jsx';
import { ProfilePage } from './Pages/ProfilePage';
import { ConfigureSourcePage } from './Pages/ConfigureSourcePage';
import { ConfigureTargetPage } from './Pages/ConfigureTargetPage';
import { DashboardPage } from './Pages/DashboardPage';
import { HelpPage } from './Pages/HelpPage';
import { PrivacyPolicyPage } from './Pages/PrivacyPolicyPage/PrivacyPolicyPage.jsx';
import { TermsOfUsePage } from './Pages/TermsOfUsePage/TermsOfUsePage.jsx';
import { NotFound } from './Pages/NotFound.jsx';
import { MfaVerificationPage } from './Pages/MfaVerificationPage/MfaVerificationPage.jsx';
import { MfaSettingsPage } from './Pages/MfaSettingsPage/MfaSettingsPage.jsx';

import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import { LogOut } from './Components';

const PrivateRoute = ({ children }) => {
  return sessionStorage.getItem( 'user' ) ? children : <Navigate to="/login" />;
};

function App() {

  return (
    <div className="d-flex flex-column min-vh-100">
      <BrowserRouter future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}>
        <Routes>
          <Route path='*' element={<NotFound />} />
          <Route path="/" element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path="product" element={<ProductPage />} />
            <Route path="document-ai" element={<DocumentAIPage />} />
            <Route path="login" element={<LoginPage />} />
            <Route path="mfa-verify" element={<MfaVerificationPage />} />
            <Route path="registration" element={<RegistrationPage />} />
            <Route path="unlock" element={<UnlockPage />} />
            <Route path="forgot-password" element={<ForgotPasswordPage />} />
            <Route path="reset-password" element={<ResetPasswordPage />} />
            <Route 
              path="profile" 
              element={
                <PrivateRoute>
                  <ProfilePage/>
                </PrivateRoute>
              } 
            >
              <Route path="configureSource" element={<ConfigureSourcePage />} />
              <Route path="configureTarget" element={<ConfigureTargetPage />} />
              <Route path="dashboard" element={<DashboardPage />} />
              <Route path="mfa-settings" element={<MfaSettingsPage />} />
            </Route>
            <Route path="help" element={<HelpPage />}></Route>
            <Route path="privacy-policy" element={<PrivacyPolicyPage />}></Route>
            <Route path="terms-of-use" element={<TermsOfUsePage />}></Route>
          </Route>
          <Route path="logout" element={<LogOut />}></Route>
          
        </Routes>
      </BrowserRouter>                    
    </div>          
  );
}

export default App
